import { render, staticRenderFns } from "./ReceivePostDatedChequesMethod.vue?vue&type=template&id=d2fa99f6&scoped=true&"
import script from "./ReceivePostDatedChequesMethod.vue?vue&type=script&lang=js&"
export * from "./ReceivePostDatedChequesMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fa99f6",
  null
  
)

export default component.exports